export default {
  roles: {
    addAttributeText: "Add an attribute",
    deleteAttributeText: "Delete an attribute",
    associatedRolesText: "Associated roles",
    addAssociatedRolesText: "Add associated roles",
    addAssociatedRolesSuccess: "Associated roles have been added",
    addAssociatedRolesError: "Could not associate roles {{error}}",
    associatedRolesModalTitle: "Add roles to {{name}}",
    title: "Realm roles",
    addRole: "Add role",
    createRole: "Create role",
    importRole: "Import role",
    roleID: "Role ID",
    homeURL: "Home URL",
    filterByClients: "Filter by clients",
    filterByRoles: "Filter by roles",
    roleExplain: "Realm-level roles are a global namespace to define your roles.",
    roleCreateExplain: "This is some description",
    roleName: "Role name",
    roleDetails: "Role details",
    composite: "Composite",
    deleteRole: "Delete this role",
    inheritedFrom: "Inherited from",
    roleList: "Role list",
    searchFor: "Search role by name",
    generalSettings: "General Settings",
    capabilityConfig: "Capability config",
    roleImportError: "Could not import role",
    roleCreated: "Role created",
    roleCreateError: "Could not create role: {{error}}",
    roleImportSuccess: "Role import successful",
    roleDeleteConfirm: "Delete role?",
    roleDeleteConfirmDialog: "This action will permanently delete the role {{selectedRoleName}} and cannot be undone.",
    roleDeletedSuccess: "The role has been deleted",
    roleDeleteError: "Could not delete role: {{error}}",
    defaultRole: "This role serves as a container for both realm and client default roles. It cannot be removed.",
    defaultRoleDeleteError: "You cannot delete a default role.",
    roleSaveSuccess: "The role has been saved",
    roleSaveError: "Could not save role: {{error}}",
    noRoles: "No roles in this realm",
    noRolesInstructions: "You haven't created any roles in this realm. Create a role to get started.",
    roleAuthentication: "Role authentication",
    removeAllAssociatedRoles: "Remove all associated roles",
    removeAssociatedRoles: "Remove associated roles",
    removeRoles: "Remove roles",
    removeAllAssociatedRolesConfirmDialog: "This action will remove the associated roles of {{name}}. Users who have permission to {{name}} will no longer have access to these roles.",
    roleRemoveAssociatedRoleConfirm: "Remove associated role?",
    roleRemoveAssociatedText: "This action will remove {{role}} from {{roleName}}. All the associated roles of {{role}} will also be removed.",
    compositeRoleOff: "Composite role turned off",
    associatedRolesRemoved: "Associated roles have been removed",
    compositesRemovedAlertDescription: "All the associated roles have been removed",
    whoWillAppearLinkText: "Who will appear in this user list?",
    whoWillAppearPopoverText: "This tab shows only the users who are assigned directly to this role. To see users who are assigned this role as an associated role or through a group, go to",
    whoWillAppearPopoverFooterText: "Users who have this role as an effective role cannot be added on this tab.",
    usersInRole: "Users in role",
    addUser: "Add user",
    removeUser: "Remove users",
    removeUserText: "Do you want to remove {{numSelected}} users?. These users will no longer have permissions of the role {{role}} and the associated roles of it.",
    noDirectUsers: "No direct users",
    noUsersEmptyStateDescription: "Only the users with this role directly assigned will appear under this tab. If you need to find users assigned to this role, go to",
    noUsersEmptyStateDescriptionContinued: "to find them. Users that already have this role as an effective role cannot be added here.",
    or: "or",
    users: "Users",
    userName: "Username",
    email: "Email",
    lastName: "Last name",
    firstName: "First name",
    clearAllFilters: "Clear all filters",
    noRolesAssociated: "No roles where associated",
    noRolesAssociatedInstructions: "To add roles to the this role press that 'Add role' button"
  }
};
